import React from 'react'
import styled from '@emotion/styled'
import { Avatar, TableCell, typography } from '@resiliatech/birdsong'

export type NameCellProps = {
  firstName: string
  lastName: string
  emailAddress: string
}

export const NameCell = ({
  firstName,
  lastName,
  emailAddress,
}: NameCellProps) => {
  const hasFullName = !!firstName && !!lastName
  const initials = hasFullName ? firstName[0] + lastName[0] : null
  const altString =
    firstName && lastName
      ? `Avatar for ${firstName} ${lastName}`
      : 'Avatar for new user'

  return (
    <TableCell>
      <CellContents>
        <Avatar alt={altString}>{initials}</Avatar>
        <NameAndEmailContainer>
          {hasFullName && (
            <div>
              {firstName} {lastName}
            </div>
          )}
          <Email hasFullName={hasFullName}>{emailAddress}</Email>
        </NameAndEmailContainer>
      </CellContents>
    </TableCell>
  )
}

const CellContents = styled.div`
  display: flex;
  align-items: center;
`

const NameAndEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 16px;
  ${typography.down2};
`

const Email = styled.div<{ hasFullName: boolean }>`
  color: ${({ hasFullName }) =>
    !hasFullName ? 'rgba(0,0,0,1)' : 'rgba(0, 0, 0, 0.60)'};
`
